export default __webpack_public_path__ + "static/media/payment.22a2a364.png";